import { Component, HostListener, Input, Renderer2 } from "@angular/core";
import { BsModalService, BsModalRef } from "ngx-bootstrap/modal";
import { AuthService } from "../../../services/auth.service";
import { ConfirmDialogComponent } from "../../../shared/components/confirm-dialog/confirm-dialog.component";
import { Routes, ActivatedRoute, Router, NavigationEnd } from "@angular/router";
import { Subscription } from "rxjs";

@Component({
  selector: "app-sidebar",
  templateUrl: "./sidebar.component.html",
  styleUrls: ["./sidebar.component.css"],
})
export class SidebarComponent {
  @Input() showSidebarAndHeader: boolean = false;
  isManagementOpen: boolean = false;
  isTaxManagementOpen: boolean = false;
  showHeader: boolean = false;
  bsModalRef?: BsModalRef;
  private routerSubscription!: Subscription;
  private clickListener!: () => void;
  admin: any = {};
  constructor(
    private modalService: BsModalService,
    private renderer: Renderer2,
    private authService: AuthService,
    private router: Router
  ) {}

  ngOnInit(): void {
    // this.admin = this.authService.getAdmin();

    this.router.events.subscribe(() => {
      const currentUrl = this.router.url;

      if (currentUrl.includes("login")) {
        this.showHeader = false;
      } else if (currentUrl.includes("signup")) {
        this.showHeader = false;
      } else if (currentUrl.includes("forget-password")) {
        this.showHeader = false;
      } else if (currentUrl.includes("questionaire")) {
        this.showHeader = false;
      } else if (currentUrl.includes("approval")) {
        this.showHeader = false;
      } else if (currentUrl.includes("reg-door")) {
        this.showHeader = false;
      } else {
        this.showHeader = true;
      }
    });

    this.routerSubscription = this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.closeSidebar();
      }
    });

    this.clickListener = this.renderer.listen(
      "document",
      "click",
      (event: Event) => {
        const sidebar = document.getElementById("bdSidebar");
        const menuIcon = document.getElementById("menuIcon");
        if (
          sidebar &&
          !sidebar.contains(event.target as Node) &&
          menuIcon &&
          !menuIcon.contains(event.target as Node)
        ) {
          this.closeSidebar();
        }
      }
    );
  }

  ngOnDestroy(): void {
    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe();
    }
    if (this.clickListener) {
      this.clickListener();
    }
  }

  scrollToSection(sectionId: string) {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  }

  dropDown(data: string, event: Event) {
    // prevent the child click event from closing the sidebar
    event.stopPropagation();

    if (data === "manager") {
      this.isManagementOpen = !this.isManagementOpen;
    } else if (data === "tax manager") {
      this.isTaxManagementOpen = !this.isTaxManagementOpen;
    }
  }

  toggleManagement() {
    this.isManagementOpen = !this.isManagementOpen;
  }
  openConfirmDialog() {
    this.bsModalRef = this.modalService.show(ConfirmDialogComponent);
    const modalComponent = this.bsModalRef.content as ConfirmDialogComponent;

    modalComponent.title = "Log Out";
    modalComponent.message = "Are you sure you want to log out?";
    modalComponent.confirmText = "Log Out";
    modalComponent.cancelText = "Cancel";
    modalComponent.confirmBtnClass = "btn btn-danger";
    modalComponent.cancelBtnClass = "btn btn-secondary";

    modalComponent.confirmEvent.subscribe(() => {});
  }

  toggleSidebar() {
    const sidebar = document.getElementById("bdSidebar");
    if (sidebar) {
      const isOpen = sidebar.classList.contains("show");
      if (isOpen) {
        this.closeSidebar();
      } else {
        this.openSidebar();
      }
    }
  }

  openSidebar() {
    const sidebar = document.getElementById("bdSidebar");
    if (sidebar) {
      sidebar.classList.add("show");
      this.addBackdrop();
    }
  }

  closeSidebar() {
    const sidebar = document.getElementById("bdSidebar");
    if (sidebar) {
      sidebar.classList.remove("show");
      this.removeBackdrop();
    }
  }

  addBackdrop() {
    let backdrop = document.querySelector(".offcanvas-backdrop");
    if (!backdrop) {
      backdrop = this.renderer.createElement("div");
      this.renderer.addClass(backdrop, "offcanvas-backdrop");
      this.renderer.addClass(backdrop, "fade");
      this.renderer.appendChild(document.body, backdrop);
    }
    this.renderer.setStyle(backdrop, "display", "block");
    this.renderer.addClass(backdrop, "show");
  }

  removeBackdrop() {
    const backdrop = document.querySelector(".offcanvas-backdrop");
    if (backdrop) {
      this.renderer.removeClass(backdrop, "show");
      this.renderer.setStyle(backdrop, "display", "none");
    }
  }

  logout() {
    this.authService.logOut();
  }
}
